export enum NotificationType {
  Transaction = 'Transaction',
}
